// Lado CLIENTE da blocklist de cadastro (sugestão #81 — cs1939).
//
// Quem decide é o servidor (`lib/server/lead-blocklist.ts`, chamado no BFF `/api/gql`): a
// lista de e-mails/domínios nunca chega ao navegador. O front só reconhece a resposta
// "bloqueado" da mutation `atendimento` e impede que o cadastro se conclua — sem isso o
// formulário gravaria `localStorage.user` mesmo com o lead recusado e liberaria as fotos.

export const LEAD_BLOCKED_STATUS = 'bloqueado';

export const MENSAGEM_LEAD_BLOQUEADO =
  'Não foi possível concluir o seu cadastro. Se você acredita que houve um engano, fale com a nossa equipe pelo WhatsApp.';

export class LeadBloqueadoError extends Error {
  constructor() {
    super('lead_bloqueado');
    this.name = 'LeadBloqueadoError';
  }
}

// `startsWith` e não igualdade: a recusa pode vir do BFF (status exatamente "bloqueado") ou
// da segunda barreira, no site-graphql, que responde "BLOQUEADO: <motivo>" quando o lead
// chega por fora do BFF. As duas têm de esconder as fotos do mesmo jeito.
export const isLeadBloqueadoResponse = (data: any): boolean =>
  String(data?.atendimento?.status ?? '')
    .trim()
    .toLowerCase()
    .startsWith(LEAD_BLOCKED_STATUS);

/**
 * Avisa o visitante e devolve a página ao estado de "não cadastrado": limpa o `user` do
 * localStorage (senão um cadastro ANTIGO continuaria liberando as fotos) e recarrega — o
 * `alert` é bloqueante, então o reload só acontece depois do OK. Quem chama deve interromper
 * o fluxo em seguida (o `throw` de sendUser), para que nada seja gravado antes do unload.
 */
export const handleLeadBloqueado = (): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem('user');
  } catch {
    // navegador sem localStorage (aba anônima travada): segue para o aviso
  }
  try {
    window.alert(MENSAGEM_LEAD_BLOQUEADO);
  } catch {
    // alert bloqueado pelo navegador: o reload abaixo já devolve a página ao estado certo
  }
  try {
    window.location.reload();
  } catch {
    // sem reload possível: quem chamou interrompe o fluxo mesmo assim (throw)
  }
};
